import { api } from "../../api/api";
import {
  DELETE_SCREEN,
  SCREEN_STATUS_DEACTIVE,
  SCREEN_STATUS_ACTIVE,
  ADD_SCREEN_REQUEST,
  ADD_SCREEN_SUCCESS,
  SCREEN_REQUEST,
  SCREEN_REQUEST_SUCCESS,
  SCREEN_REQUEST_FAILED,
  ADD_SCREEN_TO_PLAYLIST,
  ADD_PLAYLIST_TO_SCREEN,
  UNCHECK_ASSIGNED_SCREEN,
  SCREEN_FLAG_OFF,
  FIND_ONE_SCREEN,
  UPDATE_SCREEN_MEMO,
  UPDATE_SCREEN_NAME,
  ASSIGN_SCREEN_TO_STORE,
} from "../constant";

export const addScreen = (data, code) => {
  return async (dispatch) => {
    dispatch({ type: ADD_SCREEN_REQUEST, payload: "" });
    try {
      const updated = await api.patch(`/screen/update/${code}`, data);
      dispatch({ type: ADD_SCREEN_SUCCESS, payload: updated.data.screen });
    } catch (err) {
      const status = err?.response?.status;
      const data = err?.response?.data;
      let message;
      if (status === 409) {
        message = `이미 "${data?.registeredAs}"(으)로 등록된 기기입니다.`;
      } else {
        message = data?.message || '스크린 등록에 실패했습니다.';
      }
      dispatch({ type: SCREEN_REQUEST_FAILED, payload: message });
    }
  };
};
export const getScreens = (id) => {
  return async (dispatch) => {
    if (id == null || id === '') return;
    dispatch({ type: SCREEN_REQUEST, payload: "" });
    try {
      const screens = await api.get(`/screen/getscreens/${id}`);
      if (screens.status === 200) {
        const list = Array.isArray(screens.data?.screens) ? screens.data.screens : [];
        if (Array.isArray(screens.data?.screens)) {
          dispatch({ type: SCREEN_REQUEST_SUCCESS, payload: list });
        } else {
          dispatch({ type: SCREEN_REQUEST_FAILED, payload: screens.data?.message || '' });
        }
      }
    } catch (err) {
      dispatch({ type: SCREEN_REQUEST_FAILED, payload: '' });
    }
  };
};
export const screenStatusActive = (mac, status) => {
  return async (dispatch) => {
    const updated = await api.patch(
      `/screen/screenstatusupdate/${encodeURIComponent(mac)}`,
      { status }
    );
    if (updated.status === 201) {
      dispatch({
        type: SCREEN_STATUS_ACTIVE,
        payload: updated.data.updated,
      });
    }
  };
};
export const screenStatusDeActive = (mac, status) => {
  return async (dispatch) => {
    const updated = await api.patch(
      `/screen/screenstatusupdate/${encodeURIComponent(mac)}`,
      { status }
    );
    if (updated.status === 201) {
      dispatch({
        type: SCREEN_STATUS_DEACTIVE,
        payload: updated.data.updated,
      });
    }
  };
};
export const deleteScreen = (id) => {
  return async (dispatch) => {
    dispatch({
      type: DELETE_SCREEN,
      payload: id,
    });
    await api.get(`/screen/deletescreen/${id}`);
  };
};
export const addPlaylistToScreen=(obj)=>{
  return async (dispatch) => {
    const screen = await api.patch(
      `/screen/addplaylisttoscreen/${obj.id}`,
      {
        playlistId: obj.value,
      }
    );
    console.log('updated playlist assigning=',screen);
    if (screen.status === 201) {
      dispatch({
        type:ADD_PLAYLIST_TO_SCREEN,
        payload: screen.data.screen,
      });
    }
  };
}
export const uncheckAssignedScreen=(id)=>{
return async (dispatch)=>{
  dispatch({
    type:UNCHECK_ASSIGNED_SCREEN,
    payload:id
  })
}
}
export const screenFlagOff=()=>{
  return async (dispatch) => {
    dispatch({
      type:SCREEN_FLAG_OFF,
      payload:''
    })
  }
}
export const updateScreenMemo=(id, memo)=>{
  return async (dispatch) => {
    const res = await api.patch(`/screen/updatememo/${id}`, { memo });
    if (res.status === 201) {
      dispatch({ type: UPDATE_SCREEN_MEMO, payload: res.data.updated });
    }
  };
};
export const updateScreenName = (id, payload) => {
  return async (dispatch) => {
    const res = await api.patch(`/screen/updatename/${id}`, payload);
    if (res.status === 200) {
      dispatch({ type: UPDATE_SCREEN_NAME, payload: res.data.screen });
    }
    return res;
  };
};
export const findOneScreen=(id)=>{
  return async (dispatch) => {
    dispatch({
      type:FIND_ONE_SCREEN,
      payload:id
    })
  }
}
export const assignScreenToStore=(screenId, storeId)=>{
  return async (dispatch) => {
    const res = await api.patch(`/screen/assignstore/${screenId}`, { storeId });
    if (res.status === 200) {
      dispatch({ type: ASSIGN_SCREEN_TO_STORE, payload: res.data.screen });
    }
  };
}
export const assignDevice = (screenId, deviceCode) => {
  return async (dispatch) => {
    try {
      const res = await api.patch(`/screen/assign-device/${screenId}`, { deviceCode });
      if (res.status === 200) {
        dispatch({ type: 'ASSIGN_DEVICE', payload: res.data.screen });
      }
    } catch (err) {
      const data = err?.response?.data;
      dispatch({ type: SCREEN_REQUEST_FAILED, payload: data?.message || '기기 연결에 실패했습니다.' });
    }
  };
};